import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Container,
} from "@mui/material";
import { GetToken } from "../../../../actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../../utils/apidsf";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

// css
import "./CreateUser.css";

const CreateUser = () => {
  const dispatch = useDispatch();

  const selector = useSelector((state) => state);
  const navigate = useNavigate();
  const [filetoken, setfiletoken] = useState("");
  const [data, setdata] = useState({
    email: "",
    rawimage: [],
    name: "",
    category: "student",
    phone: "",
    password: "",
  });

  useEffect(() => {
    dispatch(GetToken());
  }, []);
  useEffect(() => {
    setfiletoken(selector?.adminReducer?.token);
  }, [selector]);
  const onsubmit = async () => {
    try {
      let token = JSON.parse(localStorage.getItem("token"));

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      const form = new FormData();
      form.append("file", data?.rawimage);
      await fetch("https://assets.thelexpedia.com//wp-json/wp/v2/media", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${filetoken}`,
        },
        body: form,
      })
        .then((res) => res.json())
        .then(async (result) => {
          if (result?.source_url) {
            let myValue = {
              email: data?.email,
              role: "user",
              image: result.source_url,
              name: data?.name,
              category: data?.category,
              phone: data?.phone,
              password: data?.password,
              verified: true,
            };
            try {
              await api.post(`/admin/`, myValue, config);

              swal({
                title: "Success!",
                text: "User Craeted",
                icon: "success",
                button: "Ok!",
              }).then((value) => {
                navigate("/admin/user-list");
              });
            } catch (error) {
              console.log(error?.response?.data?.error);
              swal({
                title: "Error!",
                text: error?.response?.data?.error,
                icon: "error",
                button: "Ok!",
              });
            }
          } else {
            swal({
              title: "Error!",
              text: "plz select Image ",
              icon: "error",
              button: "Ok!",
            });
          }
        });
    } catch (error) {
      console.error(error);
      swal({
        title: "Error!",
        text: error?.message,
        icon: "error",
        button: "Ok!",
      });
    }
  };

  const texttyle = {
    width: {
      xxs: 100,
      xs: 150,
      sm: 200,
      md: 300,
      lg: 400,
      xl: 500,
    },
  };

  const texttylecon = {
    width: {
      xxs: 100,
      xs: 200,
      sm: 300,
      md: 400,
      lg: 500,
      xl: 600,
    },
  };

  return (
    <div className="admin__createUser">
      <Container
        maxWidth="sm"
        sx={texttylecon}
        className="admin__createUser_div"
      >
        <Grid container spacing={2} className="All_textfield">
          <Grid item xs={12}>
            <TextField
              variant="standard"
              margin="normal"
              required
              fullWidth
              id="name"
              label="Name"
              name="name"
              type="text"
              text-align="left"
              sx={texttyle}
              InputLabelProps={{
                style: { fontSize: 15, width: "-webkit-fill-available" },
              }}
              onChange={(e) => {
                setdata({
                  ...data,
                  name: e.target.value,
                });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="standard"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              type="email"
              sx={texttyle}
              InputLabelProps={{
                style: { fontSize: 15, width: "-webkit-fill-available" },
              }}
              onChange={(e) => {
                setdata({
                  ...data,
                  email: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              variant="standard"
              margin="normal"
              required
              fullWidth
              id="phone"
              label="Phone No"
              name="phone"
              type="text"
              sx={texttyle}
              InputLabelProps={{
                style: { fontSize: 15, width: "-webkit-fill-available" },
              }}
              onChange={(e) => {
                setdata({
                  ...data,
                  phone: e.target.value,
                });
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              variant="standard"
              margin="normal"
              required
              fullWidth
              id="image"
              label="Image"
              name="image"
              type="file"
              sx={texttyle}
              InputLabelProps={{
                style: { fontSize: 15, width: "-webkit-fill-available" },
              }}
              onChange={(e) => {
                setdata({
                  ...data,
                  rawimage: e.target.files[0],
                });
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <label
              style={{
                color: "black",
              }}
            >
              {" "}
              Select Category
            </label>
            <br></br>
            <select
              value={data?.category}
              onChange={(e) => {
                setdata({
                  ...data,
                  category: e.target.value,
                });
              }}
            >
              <option value="student">student</option>
              <option value="teacher">teacher</option>
              <option value="lawyer">lawyer</option>
            </select>
          </Grid>

          <Grid item xs={12}>
            <TextField
              variant="standard"
              margin="normal"
              required
              fullWidth
              id="password"
              label="Password"
              name="password"
              type="text"
              sx={texttyle}
              InputLabelProps={{
                style: { fontSize: 15, width: "-webkit-fill-available" },
              }}
              onChange={(e) => {
                setdata({
                  ...data,
                  password: e.target.value,
                });
              }}
            />
          </Grid>

          <br></br>

          <Grid item xs={12}>
            <Grid>
              <FormControl sx={texttyle}>
                {" "}
                <br />
                <Button
                  className="create_user_btn"
                  variant="contained"
                  onClick={() => onsubmit()}
                >
                  Add User
                </Button>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default CreateUser;
